import { ErrorHandler } from 'libs/error/index';

/* eslint-disable no-console */
export class ConsoleErrorHandler implements ErrorHandler {
  handle(error?: Error) {
    console.error(error);
  }
}
/* eslint-enable no-console */
